export const getTileX = (
  i: number,
  horizontalSplit: number,
  verticalSplit: number
) => {
  const currentRow = Math.floor(i / horizontalSplit) + 1
  const tileHeight = 100 / verticalSplit

  return tileHeight * currentRow - tileHeight
}

export const getTileY = (i: number, horizontalSplit: number) => {
  const currentCol = (i % horizontalSplit) + 1
  const tileWidth = 100 / horizontalSplit

  return (100 / horizontalSplit) * currentCol - tileWidth
}

export const hasNextItem = (index: number, length: number) => index < length - 1

export const hasPrevItem = (index: number) => index > 0
